import React from "react";
import OfferMadeSection from "./OfferMadeSection";
import ReceivedOfferSection from "./ReceivedOfferSection";
import { Card, CardContent, Grid, Typography } from "@mui/material";
import { Helmet } from "react-helmet-async";
import AnalyticsTracker from "../../GASetup/AnalyticsTracker";
import { cardOutline, headingFonts } from "../../../Styles/Styles";

export default function Offers() {
  return (
    <Grid container spacing={3} sx={{ p: 3, mb: 5 }}>
      <Helmet>
        <title>Offers - Listed.ky</title>
        <meta name="description" content="Offers - Listed.ky" />
      </Helmet>
      <AnalyticsTracker />
      <Grid container spacing={3} sx={{ p: 3 }}>
        <Grid item xs={12} md={12}>
          <Card sx={{ ...cardOutline }}>
            <CardContent>
              <Typography variant="h5" gutterBottom sx={{ ...headingFonts }}>
                Received Offers
              </Typography>
              <ReceivedOfferSection />
            </CardContent>
          </Card>
        </Grid>
      </Grid>
      <Grid container spacing={3} sx={{ p: 3 }}>
        <Grid item xs={12} md={12}>
          <Card sx={{ ...cardOutline }}>
            <CardContent>
              <Typography variant="h5" gutterBottom sx={{ ...headingFonts }}>
                Offers Made to Others
              </Typography>
              <OfferMadeSection />
            </CardContent>
          </Card>
        </Grid>
      </Grid>
    </Grid>
  );
}
